export interface NavItem {
  to: string;
  label: string;
  /** react-router `end` matching — only the Home `/` link needs it. */
  end?: boolean;
}

/**
 * Single source of truth for the primary navigation, shared by the desktop
 * {@link Nav} and the mobile {@link MobileNav} (Variant B). Order mirrors the
 * design's `EF.NAV`.
 */
export const navLinks: NavItem[] = [
  { to: '/', label: 'Home', end: true },
  { to: '/cardio', label: 'Cardio' },
  { to: '/strength', label: 'Strength' },
  { to: '/body', label: 'Body' },
  { to: '/health', label: 'Health' },
  { to: '/diet', label: 'Diet' },
  { to: '/feed', label: 'Feed' },
  { to: '/medical', label: 'Medical Test' },
  { to: '/calendar', label: 'Calendar' },
];

/**
 * Label of the nav section a path belongs to — exact match first, then the
 * longest non-root prefix (so `/cardio/123` resolves to "Cardio"). Empty string
 * when nothing matches (a standalone route outside the nav).
 */
export function navLabelForPath(pathname: string): string {
  const exact = navLinks.find((l) => l.to === pathname);
  if (exact) return exact.label;
  const prefix = navLinks
    .filter((l) => l.to !== '/' && pathname.startsWith(`${l.to}/`))
    .sort((a, b) => b.to.length - a.to.length)[0];
  return prefix?.label ?? '';
}
